import { Link } from 'react-router-dom';
import { cx } from '../ui';

/** Wordmark with the fir mark. `light` for the dark brand panel on the auth pages. */
export function Brand({ to = '/', light = false }: { to?: string; light?: boolean }) {
  return (
    <Link to={to} className={cx('brand', light && 'brand--light')} aria-label="Balsam Hub">
      <svg className="brand__mark" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M10 1.5 4.5 9.5h3L3.5 16h13l-4-6.5h3Z" fill="currentColor" />
        <path d="M9.25 16h1.5v2.5h-1.5Z" fill="currentColor" />
      </svg>
      <span>Balsam Hub</span>
    </Link>
  );
}
